import React from 'react'
import { Button } from '@material-ui/core'
import { Link } from 'react-router-dom'

const NotFoundAuth = () => {
    return (
        <div className="flex justify-center items-center h-full-screen w-full">
            <div className="flex-column justify-center items-center max-w-320">
                <h2 className="mb-8">Доступ запрещен!</h2>
                <img
                    className="mb-8 w-full"
                    src="/assets/images/illustrations/dreamer.svg"
                    alt=""
                />
                <Link to="/">
                    <Button
                        className="capitalize"
                        variant="contained"
                        color="primary"
                    >
                        Вернуться на главную
                    </Button>
                </Link>
            </div>
        </div>
    )
}

export default NotFoundAuth
